// extracted by mini-css-extract-plugin
module.exports = {"button":"_f8a9236"};